import EdCheckbox from '@Components/UI/Inputs/EdCheckbox/EdCheckbox';
import EdFormControl from '@Components/UI/Inputs/EdFormControl/EdFormControl';
import { EdFormControlLabel } from '@Components/UI/Inputs/EdFormControlLabel/EdFormControlLabel';
import { useTypedSelector } from '@Features/store';
import { Switch } from '@mui/material';
import { FlexLayout, GridLayout } from '@Styled/utilities';
import React, { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { TestPayload } from '../../../../../Types/Test/Test.types';
import { StyledInfoLabel } from '../TestOptions.styled';

const TestOptionsGeneralSection = () => {
	const { control, watch } = useFormContext<TestPayload>();
	const {
		currentEntity: { active },
	} = useTypedSelector((state) => state.Tests);
	const showPeriod = watch('showTestPeriod');
	return (
		<>
			<StyledInfoLabel m={0} mb={'2.5rem'}>
				Activation options
			</StyledInfoLabel>
			<GridLayout px={'1rem'} mb="2rem" gridColumnGap={'3rem'}>
				<FlexLayout justifyContent={'space-between'}>
					<EdFormControlLabel>Mannual test activation</EdFormControlLabel>
					<Controller
						control={control}
						name="test.active"
						render={({ field: { value } }) => {
							return <Switch checked={value} disabled />;
						}}
					/>
				</FlexLayout>
				<FlexLayout>
					<EdCheckbox
						disabled={active}
						control={control}
						name="showTestPeriod"
						label={'Set period'}
					/>
					{showPeriod && (
						<FlexLayout
							justifyContent={'space-around'}
							flex={'2'}
							justifyItems={'end'}
						>
							<EdFormControl
								disabled={active}
								type="datetime-local"
								control={control}
								name="test.active_start_date"
								label={'start'}
								showLabel={false}
								width={'8.75rem'}
							/>
							<EdFormControl
								disabled={active}
								showLabel={false}
								width={'8.75rem'}
								type="datetime-local"
								control={control}
								name="test.active_end_date"
								label={'end'}
							/>
						</FlexLayout>
					)}
				</FlexLayout>
			</GridLayout>
		</>
	);
};

export default TestOptionsGeneralSection;
